import { render } from "./ForeignTradeByCountries.vue?vue&type=template&id=d077c962&ts=true"
import script from "./ForeignTradeByCountries.vue?vue&type=script&lang=ts"
export * from "./ForeignTradeByCountries.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__